import { Link } from 'react-router-dom';
import styles from './BasicInformation.module.scss';
import { useTranslation } from '../../i18n/useTranslation';

export default function BasicInformation() {
    const { t } = useTranslation('translation');
    return (
        <div className={styles.container}>
            <div className={styles.header}>{t('BASIC_INFORMATION')}</div>
            <div className={styles.text}>{t('loginForm.MESSAGE_1')}</div>
            <button><Link to='/Engineering'>{t('MORE_DETAILS')}</Link></button>
        </div>
    )
}